import axios from "axios";

const API = axios.create({
    // baseURL: "http://127.0.0.1:8000"
    baseURL: "https://api.mealno.in"
    // baseURL: "https://test.api.mealno.in"

});

// 1. REQUEST INTERCEPTOR: Attach Access Token
API.interceptors.request.use((req) => {
    const token = localStorage.getItem("delivery_access_token"); // ✅ Looking for new key
    if (token && token !== "undefined" && token !== "null") {
        req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
});

// 2. RESPONSE INTERCEPTOR: Auto-Refresh Logic
API.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // Catch 401 Unauthorized errors
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            // Stop loops on auth endpoints
            if (originalRequest.url === '/auth/refresh' || originalRequest.url === '/delivery/login') {
                return Promise.reject(error);
            }

            try {
                const refreshToken = localStorage.getItem("delivery_refresh_token");

                if (!refreshToken) {
                    throw new Error("No refresh token available");
                }

                // Hit backend to exchange refresh token
                const res = await axios.post(`${API.defaults.baseURL}/auth/refresh`, {
                    refresh_token: refreshToken
                });

                const newAccessToken = res.data.access_token;

                // Save the new access token
                localStorage.setItem("delivery_access_token", newAccessToken);

                // Retry the original failed request
                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                return API(originalRequest);

            } catch (refreshError) {
                // If refresh fails, wipe state and force login
                localStorage.removeItem("delivery_access_token");
                localStorage.removeItem("delivery_refresh_token");
                localStorage.removeItem("deliveryBoy");

                window.location.href = "/";
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

// 🔐 LOGIN
export const loginDelivery = (data) => API.post("/delivery/login", data);

// 📦 GET WORK (batch or single order)
export const getMyWork = () => API.get("/delivery/my-work");

// 📦 GET BATCH DETAILS
export const getBatchDetails = (id) => API.get(`/delivery/batch/${id}`);

// 📦 GET ORDER DETAILS
export const getOrderDetails = (id) => API.get(`/delivery/order/${id}`);

// ✅ UPDATE ORDER STATUS
export const updateOrderStatus = (data) => API.put("/delivery/order/status", data);

// ✅ UPDATE BATCH STATUS
export const updateBatchStatus = (data) => API.put("/delivery/batch/status", data);

// 🚨 CANCEL ORDER
export const cancelOrderByDelivery = (data) => API.put("/delivery/order/cancel", data);

// ✅ TOGGLE ONLINE / OFFLINE
export const toggleStatus = () => API.put("/delivery/toggle-status");

export const completeOrder = (data) => API.post("/delivery/complete-order", data);

export const getDeliveryHistory = () => API.get("/delivery/history");

export const getUpiDetails = (orderId) => API.get(`/delivery/order/${orderId}/upi`);

export const uploadPaymentProof = (formData) =>
    API.post("/delivery/upload-payment-proof", formData, {
        headers: { "Content-Type": "multipart/form-data" }
    });

export const getDeliveryProfile = () => API.get("/delivery/me");

export default API;